// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__21sKs","notes":"Notes_notes__U_X8z","note":"Notes_note__1ASIz","markdown":"Notes_markdown__1BbF9"};